import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'LKR') {
  return new Intl.NumberFormat('en-LK', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  }).format(amount || 0);
}

export function formatDate(date) {
  if (!date) return 'N/A';
  return new Intl.DateTimeFormat('en-LK', {
    dateStyle: 'medium',
  }).format(new Date(date));
}

export function getStatusColor(status) {
  const colors = {
    pending: 'bg-amber-100 text-amber-700 border-amber-200',
    approved: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    active: 'bg-blue-100 text-blue-700 border-blue-200',
    rejected: 'bg-rose-100 text-rose-700 border-rose-200',
    completed: 'bg-slate-100 text-slate-700 border-slate-200',
  };
  return colors[status?.toLowerCase()] || 'bg-slate-100 text-slate-700 border-slate-200';
}